import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { LuppApi } from '../lupp.service';
import { LUPP_QUERY_KEYS } from '../constants.lupp';
import {
  CreateNoteRequest,
  CreateNoteResponse,
  NoteEntityType,
  SearchNotesRequest,
  SearchNotesResponse,
} from './dto.notes';

/*
|--------------------------------------------------------------------------
| SEARCH NOTES
|--------------------------------------------------------------------------
*/

export const useSearchNotes = (
  entityIdentifier: string,
  entityType: NoteEntityType,
  enabled = true
) => {
  return useQuery({
    queryKey: [LUPP_QUERY_KEYS.NOTES, entityIdentifier, entityType],
    queryFn: async () => {
      const body: SearchNotesRequest = {
        entityIdentifier,
        entityType,
      };
      const response = await LuppApi.post<SearchNotesRequest, SearchNotesResponse>(
        'shared/notes/v1/notes/searches',
        body,
        {
          extractData: (response) => response,
        }
      );
      return response;
    },
    enabled: enabled && !!entityIdentifier && !!entityType,
  });
};

/*
|--------------------------------------------------------------------------
| CREATE NOTE
|--------------------------------------------------------------------------
*/

export const useCreateNote = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: CreateNoteRequest) => {
      const response = await LuppApi.post<CreateNoteRequest, CreateNoteResponse>(
        'shared/notes/v1/notes',
        data,
        {
          extractData: (response) => response,
        }
      );
      return response;
    },
    onSuccess: (_data, variables) => {
      // Invalidate notes to refresh comments
      queryClient.invalidateQueries({
        queryKey: [LUPP_QUERY_KEYS.NOTES, variables.entityIdentifier],
      });
    },
  });
};
